
export default {
	loading: false,
	cargoCarrierTypes: [],
	errors: {
		iconId: false,

		id: '',
	}
};
